import { HttpStatus, type HttpStatusCode, type UpperSnakeCase } from '../../lib/entry.js';
import { type ErrorCode, PoolbettingError } from './PoolbettingError.js';

/**
 * Error instance representing an application error which cannot be recovered from, like some internal application logic.
 * ApplicationError this is a sibling to InternalError.
 */
export class ApplicationError<TCode extends string = ErrorCode> extends PoolbettingError<TCode | 'INTERNAL'> {
  protected override httpStatus: HttpStatusCode = HttpStatus.InternalServerError;

  constructor(
    message = 'Request error',
    options?: ErrorOptions,
    code: (TCode & UpperSnakeCase<TCode>) | 'INTERNAL' = 'INTERNAL'
  ) {
    super(message, options, code);
    this.name = 'ApplicationError';
  }
}
